/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const es_persons_create_invitation_button_submit = /** @type {(inputs: {}) => string} */ () => {
	return `Enviar Invitación`
};

const en_persons_create_invitation_button_submit = /** @type {(inputs: {}) => string} */ () => {
	return `Send Invitation`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const persons_create_invitation_button_submit = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.persons_create_invitation_button_submit(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("persons_create_invitation_button_submit", locale)
	if (locale === "es") return es_persons_create_invitation_button_submit(inputs)
	return en_persons_create_invitation_button_submit(inputs)
};
export { persons_create_invitation_button_submit as "persons.create_invitation.button_submit" }